import React, { useState } from 'react';
import { supabase } from './supabaseClient';
import { t } from './i18n';

function GdprOnboarding({ user, rolUser, onAccept }) {
  const [acordPrelucrare, setAcordPrelucrare] = useState(false);
  const [acordTermeni, setAcordTermeni] = useState(false);
  const [acordDpa, setAcordDpa] = useState(false);
  const [acordMarketing, setAcordMarketing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [eroare, setEroare] = useState('');

  // DPA e obligatoriu doar pentru clienți, nu pentru manageri/admini
  const necesitaDpa = rolUser === 'client';

  // Verifică dacă toate acordurile obligatorii sunt bifate
  const toateObligatoriileBifate = () => {
    if (necesitaDpa) {
      return acordPrelucrare && acordTermeni && acordDpa;
    }
    return acordPrelucrare && acordTermeni;
  };

  const handleAccept = async () => {
    if (!toateObligatoriileBifate()) {
      setEroare(t('gdpr', 'eroareBife'));
      return;
    }

    setLoading(true);
    setEroare('');

    try {
      // Obține IP-ul utilizatorului (best effort, nu blocăm dacă eșuează)
      let ipAddress = null;
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();
        ipAddress = ipData.ip;
      } catch (err) {
        console.warn('Nu am putut obține IP-ul:', err);
      }

      const { error } = await supabase.from('acorduri_gdpr').insert({
        user_id: user.id,
        acord_prelucrare_date: acordPrelucrare,
        acord_termeni_conditii: acordTermeni,
        acord_dpa: necesitaDpa ? acordDpa : false,
        acord_marketing: acordMarketing,
        ip_address: ipAddress,
        user_agent: navigator.userAgent,
        versiune_documente: 'v1.0',
        rol_user: rolUser,
      });

      if (error) throw error;

      // Notifică componenta părinte că acordul a fost salvat
      onAccept();
    } catch (err) {
      console.error('Eroare salvare acord GDPR:', err);
      setEroare(t('gdpr', 'eroareSalvare'));
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>NM Social</div>
        <h1 style={styles.titlu}>{t('gdpr', 'titlu')}</h1>
        <p style={styles.subtitlu}>
          {t('gdpr', 'subtitlu')}
        </p>

        <div style={styles.listaAcorduri}>
          {/* Acord 1 — Prelucrare date personale */}
          <label style={styles.acord}>
            <input
              type="checkbox"
              checked={acordPrelucrare}
              onChange={(e) => setAcordPrelucrare(e.target.checked)}
              style={styles.checkbox}
            />
            <span style={styles.textAcord}>
              <strong>{t('gdpr', 'dateTitlu')}</strong> *
              <br />
              <span style={styles.descriere}>
                {t('gdpr', 'dateInainte')}
                <a href="/privacy" target="_blank" rel="noopener noreferrer" style={styles.link}>
                  {t('gdpr', 'dateLink')}
                </a>
                .
              </span>
            </span>
          </label>

          {/* Acord 2 — Termeni și Condiții */}
          <label style={styles.acord}>
            <input
              type="checkbox"
              checked={acordTermeni}
              onChange={(e) => setAcordTermeni(e.target.checked)}
              style={styles.checkbox}
            />
            <span style={styles.textAcord}>
              <strong>{t('gdpr', 'termeniTitlu')}</strong> *
              <br />
              <span style={styles.descriere}>
                {t('gdpr', 'termeniInainte')}
                <a href="/terms" target="_blank" rel="noopener noreferrer" style={styles.link}>
                  {t('gdpr', 'termeniLink')}
                </a>{t('gdpr', 'termeniDupa')}
              </span>
            </span>
          </label>

          {/* Acord 3 — DPA (doar pentru clienți) */}
          {necesitaDpa && (
            <label style={styles.acord}>
              <input
                type="checkbox"
                checked={acordDpa}
                onChange={(e) => setAcordDpa(e.target.checked)}
                style={styles.checkbox}
              />
              <span style={styles.textAcord}>
                <strong>{t('gdpr', 'dpaTitlu')}</strong> *
                <br />
                <span style={styles.descriere}>
                  {t('gdpr', 'dpaText')}
                </span>
              </span>
            </label>
          )}

          {/* Acord 4 — Marketing (opțional) */}
          <label style={styles.acord}>
            <input
              type="checkbox"
              checked={acordMarketing}
              onChange={(e) => setAcordMarketing(e.target.checked)}
              style={styles.checkbox}
            />
            <span style={styles.textAcord}>
              <strong>{t('gdpr', 'marketingTitlu')}</strong> {t('gdpr', 'marketingOptional')}
              <br />
              <span style={styles.descriere}>
                {t('gdpr', 'marketingText')}
              </span>
            </span>
          </label>
        </div>

        {eroare && <div style={styles.eroare}>{eroare}</div>}

        <button
          onClick={handleAccept}
          disabled={loading || !toateObligatoriileBifate()}
          style={{
            ...styles.buton,
            opacity: loading || !toateObligatoriileBifate() ? 0.5 : 1,
            cursor:
              loading || !toateObligatoriileBifate() ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? t('gdpr', 'seSalveaza') : t('gdpr', 'acceptaSiContinua')}
        </button>

        <p style={styles.notaJos}>
          {t('gdpr', 'notaJos')}
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F5F9F6',
    padding: '20px',
    fontFamily: "'DM Sans', sans-serif",
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '40px',
    maxWidth: '600px',
    width: '100%',
    boxShadow: '0 4px 20px rgba(26, 107, 60, 0.08)',
  },
  logo: {
    fontFamily: "'DM Serif Display', serif",
    fontSize: '28px',
    color: '#1A6B3C',
    marginBottom: '8px',
  },
  titlu: {
    fontFamily: "'DM Serif Display', serif",
    fontSize: '32px',
    color: '#1A1A1A',
    margin: '0 0 12px 0',
  },
  subtitlu: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '32px',
    lineHeight: '1.5',
  },
  listaAcorduri: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBottom: '24px',
  },
  acord: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    cursor: 'pointer',
    padding: '16px',
    backgroundColor: '#FAFBFA',
    borderRadius: '8px',
    border: '1px solid #E8EDE9',
    transition: 'all 0.2s',
  },
  checkbox: {
    marginTop: '4px',
    width: '18px',
    height: '18px',
    cursor: 'pointer',
    accentColor: '#1A6B3C',
    flexShrink: 0,
  },
  textAcord: {
    fontSize: '14px',
    color: '#1A1A1A',
    lineHeight: '1.5',
  },
  descriere: {
    fontSize: '13px',
    color: '#666',
  },
  link: {
    color: '#1A6B3C',
    textDecoration: 'underline',
  },
  eroare: {
    backgroundColor: '#FEF2F2',
    color: '#B91C1C',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    marginBottom: '16px',
    border: '1px solid #FCA5A5',
  },
  buton: {
    width: '100%',
    padding: '14px 24px',
    backgroundColor: '#1A6B3C',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    fontFamily: "'DM Sans', sans-serif",
    transition: 'all 0.2s',
  },
  notaJos: {
    fontSize: '12px',
    color: '#999',
    marginTop: '16px',
    marginBottom: 0,
    textAlign: 'center',
  },
};

export default GdprOnboarding;